export default __webpack_public_path__ + "static/media/oem-auto-parts.a5d04970.png";